export type ServiceType = "cleaning" | "staffing" | "hospitality" | "custom";

export type ServiceRequestDetail = { type: ServiceType; note?: string };

export const SERVICE_REQUEST_EVENT = "flexhire:service-request";

/** Pre-fills the estimate form when a visitor clicks a service-specific link. */
export function requestService(type: ServiceType, note?: string) {
  window.dispatchEvent(
    new CustomEvent<ServiceRequestDetail>(SERVICE_REQUEST_EVENT, { detail: { type, note } })
  );
}
